var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-date-picker-cell",class:_vm.cls,on:{"mouseenter":_vm.followMe,"click":_vm.choose}},[_c('div',{ref:"text",staticClass:"fm-date-picker-cell-text",class:_vm.cellCls,domProps:{"innerHTML":_vm._s(_vm.cellText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }